<button class="lite-button" [class.lite-button--block]="block()" (click)="buttonClick.emit()">
  <i class="pi pi-{{ icon() }} lite-button__icon"></i>
  {{ text() }}
</button>
